import { AirplaneTakeoffIcon } from './AirplaneTakeoffIcon';

/**
 * author: Google
 * id 2B9BB7A1-A94B-4D24-8308-5599504317C2
 * name airplane-takeoff
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-takeoff.svg
 * tags
 * - Transportation + Flying 
 */
export const PlaneTakeoffIcon = AirplaneTakeoffIcon;
export default PlaneTakeoffIcon